import { ONBOARDING_V3_EVENT_NAME, PATHWAYS_ONBOARDING_EVENT_NAME } from 'bundles/onboarding-common/constants';
import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import useIsFromUnregisteredOnboarding from 'bundles/onboarding-common/hooks/useIsFromUnregisteredOnboarding';
import useLearnerOnboardingQuery from 'bundles/onboarding-common/hooks/useLearnerOnboardingQuery';
import { getHasSeenLoggedOutOnboarding } from 'bundles/onboarding-common/utils/cookieUtils';
import { getLocalStorageOnboardingData } from 'bundles/onboarding-common/utils/localStorageUtils';

/**
 * Shared hook for calculating onboarding eligibility logic
 * Used by both redirect and V3 eligibility hooks
 */
const useOnboardingEligibility = () => {
  const { hasSeenOnboarding, onboardingVersion, loading } = useLearnerOnboardingQuery();
  const { isFromUnregisteredOnboardingSignupFlow } = useIsFromUnregisteredOnboarding();
  const hasSeenLoggedOutOnboarding = getHasSeenLoggedOutOnboarding();

  const localStorageOnboardingData = getLocalStorageOnboardingData();
  const hasLocalStorageOnboardingData =
    !!localStorageOnboardingData && !!localStorageOnboardingData?.[QUESTION_IDS.learningGoal];

  const isFromUnregisteredOnboarding =
    isFromUnregisteredOnboardingSignupFlow || hasLocalStorageOnboardingData || hasSeenLoggedOutOnboarding;

  const onboardingVersionNotPathways = onboardingVersion
    ? ![PATHWAYS_ONBOARDING_EVENT_NAME, ONBOARDING_V3_EVENT_NAME].includes(onboardingVersion)
    : true;

  const shouldRetriggerPathwaysOnboarding = !loading && hasSeenOnboarding && onboardingVersionNotPathways;

  const isEligibleForOnboardingV3 =
    !loading &&
    !!(
      onboardingVersion === ONBOARDING_V3_EVENT_NAME ||
      hasSeenOnboarding === false ||
      shouldRetriggerPathwaysOnboarding
    );

  const shouldRedirectToOnboarding =
    !loading && !isFromUnregisteredOnboarding && (hasSeenOnboarding === false || shouldRetriggerPathwaysOnboarding);

  return {
    hasSeenOnboarding,
    onboardingVersion,
    loading,
    onboardingVersionNotPathways,
    shouldRetriggerPathwaysOnboarding,
    isEligibleForOnboardingV3,
    shouldRedirectToOnboarding,
  };
};

export default useOnboardingEligibility;
